import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './Hyperlink.types.js';
import styles from './Hyperlink.module.scss.js';

var Hyperlink = /** @class */ (function (_super) {
    __extends(Hyperlink, _super);
    function Hyperlink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hyperlink.prototype.render = function () {
        var _a = this.props, children = _a.children, variant = _a.variant, color = _a.color, renderExternalLinkIcon = _a.renderExternalLinkIcon, className = _a.className, size = _a.size, rest = __rest(_a, ["children", "variant", "color", "renderExternalLinkIcon", "className", "size"]);
        return (React__default.createElement("a", __assign({ style: {
                color: color && color !== 'blue' && color !== 'black'
                    ? color
                    : '',
                fontSize: size !== null && size !== void 0 ? size : '14px',
            }, className: clsx(styles.Hyperlink, variant === 'block' && styles.Hyperlink___block, color === 'black' && styles.Hyperlink___black, className) }, rest),
            children,
            renderExternalLinkIcon && (React__default.createElement(Icon, { className: styles.Hyperlink_externalIcon, name: "ExternalLinkIcon", alt: "external-link-icon", "data-testid": "external-link-icon", size: size }))));
    };
    Hyperlink.displayName = 'Hyperlink';
    Hyperlink.propTypes = propTypes;
    Hyperlink.defaultProps = __assign({}, defaultProps);
    return Hyperlink;
}(React__default.Component));

export { Hyperlink, Hyperlink as default };
